'use client';

import React, { memo } from 'react';
import { CenteredContainer } from '@ianesthesie-kit/core';
import { Box, BoxProps, CircularProgress } from '@mui/material';

interface LoaderProps extends BoxProps {
  translucent?: true;
}

const UnmemoLoader = ({ translucent, ...props }: LoaderProps) => (
  <CenteredContainer
    position="absolute"
    top={0}
    left={0}
    width="100%"
    zIndex={999}
    bgcolor={translucent && 'rgba(255,255,255, 0.5)'}
    {...props}
    sx={{
      height: '100vh',
      ...props.sx
    }}
  >
    <Box position="relative" bottom={40}>
      <CircularProgress thickness={4} size={48} variant="indeterminate" />
    </Box>
  </CenteredContainer>
);

export const Loader = memo(UnmemoLoader);
